import { openFeedbackModal } from './FeedbackModal.js';

const FELT = '#0d2c1d';
const GOLD = '#d4af37';

let buttonEl: HTMLButtonElement | null = null;
let currentRoute: string = 'lobby';

export function setFeedbackRoute(route: string): void {
  currentRoute = route;
}

export function mountFeedbackButton(): void {
  if (buttonEl) return;
  const b = document.createElement('button');
  b.type = 'button';
  b.setAttribute('aria-label', 'Send feedback');
  b.title = 'Send feedback';
  b.innerHTML = `
    <svg viewBox="0 0 24 24" width="22" height="22" fill="none"
         stroke="${GOLD}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
         aria-hidden="true">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
    </svg>`;
  b.style.cssText = [
    'position:fixed',
    'bottom:calc(env(safe-area-inset-bottom, 0px) + 12px)',
    'right:calc(env(safe-area-inset-right, 0px) + 12px)',
    'z-index:1000',
    'width:44px', 'height:44px', 'padding:0',
    'border-radius:50%',
    `background:${FELT}`,
    `border:2px solid ${GOLD}`,
    'box-shadow:0 4px 14px rgba(0,0,0,0.5)',
    'cursor:pointer',
    'display:flex', 'align-items:center', 'justify-content:center',
    'transition:transform 120ms,box-shadow 120ms',
  ].join(';');
  b.addEventListener('mouseenter', () => {
    b.style.transform = 'scale(1.06)';
    b.style.boxShadow = '0 6px 18px rgba(0,0,0,0.6)';
  });
  b.addEventListener('mouseleave', () => {
    b.style.transform = 'scale(1)';
    b.style.boxShadow = '0 4px 14px rgba(0,0,0,0.5)';
  });
  b.addEventListener('click', () => openFeedbackModal({ route: currentRoute }));
  document.body.append(b);
  buttonEl = b;
}
